import HelpScrollArea from 'components/common/help-scroll-area';
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";

import {
  useLazyGetTnvedHierarchyQuery,
} from "../../../../../../../../../../../../../../../../../api/dictionary";
import Preloader from "../../../../../../../../../../../../../../../../common/preloader";
import HelpTabsSearchField from "../../../search-field";

import TnvedTree from "../tnved-tree";

import './guide_list.scss'

const GuideList = ({handleApplyCode, code}: GuideListProps) => {

  const { t } = useTranslation()

  const [ tnvedHierarchyRequest ] = useLazyGetTnvedHierarchyQuery()

  const [ searchCode, setSearchCode ] = useState(code || '');

  const [ categories, setCategories ] = useState<TnvedHierarchyDictionaryItem[] | null>(null);
  const [ notFoundError, setNotFoundError ] = useState<boolean | string>(false);
  const [ isLoading, setIsLoading ] = useState<boolean | string>(true);

  const loadHierarchy = (code: string | undefined) => {

    setIsLoading(true);
    setSearchCode(code || '');

    const promise = tnvedHierarchyRequest({ code: code?.replace(/\s+/g, "") });

    promise
      .unwrap()
      .then((resp) => {
        const hierarchy = resp.data;

        if (!hierarchy) {
          setCategories([]);
          return;
        }

        setCategories(hierarchy);
        setNotFoundError(false);
      })
      .catch((error) => {
        setNotFoundError(error?.data?.error || t("calc__text__main__noOptionsFound"));
        setCategories([]);
      })
      .finally(() => {
        setIsLoading(false);
      })

  };

  useEffect(() => {
    loadHierarchy(code);
  }, [ code ]);

  const updateTree = (
    tree: TnvedHierarchyDictionaryItem[],
    hierarchy: TnvedHierarchyDictionaryItem[]
  ): TnvedHierarchyDictionaryItem[] => {

    return tree.map((node) => {
      if (node.id === hierarchy[0].id) {
        return {
          ...node,
          children: hierarchy[0].children || [],
        };
      }

      if (node.children?.length) {
        return {
          ...node,
          children: updateTree(node.children, hierarchy),
        };
      }

      return node;
    });
  };

  const handleSearch = (code: string) => {
    if (!code) {
      setNotFoundError(false);
      loadHierarchy(undefined);
      return;
    }

    loadHierarchy(code);
  };

  const handleToggle = (id: string | number, code?: string) => {

    let promise;

    if (code) {
      promise = tnvedHierarchyRequest({ code });
    } else {
      promise = tnvedHierarchyRequest({ id });
    }

    promise
      .unwrap()
      .then((resp) => {
        const hierarchy = resp.data;

        if (!hierarchy) {
          return;
        }

        setCategories((prev) => (prev ? updateTree(prev, hierarchy) : prev));
      })
      .catch(() => {});
  };

  const shouldShowList =
      !notFoundError && categories && categories.length > 0 && !isLoading;

  if (!categories && !isLoading) return null;

  return <>
    <HelpTabsSearchField
      onSearch={handleSearch}
      label={t('calc__text__packaging__HSCodeSearch')}
      noValidationOnBlur
    />
    {notFoundError && <Typography variant='caption' sx={{ marginTop: 1, display: 'inline-block' }}>
      {notFoundError || t('calc__text__main__noOptionsFound')}
    </Typography>}
    {isLoading && (<div className='guide-preloader'>
      <Preloader/>
    </div>)}
    {shouldShowList && <HelpScrollArea persistentScrollbar className='guide-list' contentClassName='guide-list__content' label={t('common__text__guide')}>
      <TnvedTree code={searchCode} data={categories} onToggle={handleToggle} handleApplyCode={handleApplyCode} />
    </HelpScrollArea>}
  </>

}

export default GuideList

